import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { withTranslation } from "react-i18next";
import withRouter from "../../../../../components/Common/withRouter";

const DisableConfirmationModal = ({
  isOpen,
  toggle,
  onConfirm,
  isDisabling,
  deductionToDisable,
  t
}) => {
  if (!deductionToDisable) return null;

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Confirm Disable</ModalHeader>

      <ModalBody>
       {t("are_you_sure_disable")}<strong>{deductionToDisable.deduction.name}</strong>?
      </ModalBody>

      <ModalFooter>
        <Button 
          color="warning" 
          onClick={() => onConfirm(deductionToDisable)}
          disabled={isDisabling}
        >
          {isDisabling ? "Disabling..." : "Disable"}
        </Button>
        <Button color="secondary" onClick={toggle}>Cancel</Button>
      </ModalFooter>
    </Modal>
  );
};
export default withRouter(withTranslation()(DisableConfirmationModal));
